import axios from 'axios';
// eslint-disable-next-line import/no-unresolved,import/no-extraneous-dependencies, import/extensions
import config from 'config';
import Vue from 'vue';

const state = {
	tickets: {},
	ticket: '',
};

const actions = {
	getTickets: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/ticket?api_key=${
				payload.apiKey
			}&filter=${payload.filter}&page=${payload.page}&results=${payload.results}`)
			.then(
				(response) => {
					resolve(response);
					commit('setTickets', response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
	}),

	getTicket: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/ticket/${payload.ticketId}?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setTicket', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.data);
			});
	}),

	updateTicket: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.put(`${config.api}/politician/${payload.userId}/ticket/${payload.ticketId}?api_key=${
				payload.apiKey}&assignee_id=${(payload.assignee || {}).id || ''}&status=${
				payload.status || ''}&response=${payload.response || ''}`)
			.then((response) => {
				resolve(response);
				// commit('setTicket', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.data);
			});
	}),

	getUsers: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/politician/${payload.userId}/users?api_key=${ payload.apiKey }`)
			.then(
				(response) => {
					resolve(response.data);
				},
				(error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				},
			);
	}),
};

const mutations = {
	setTickets: (state, payload) => {
		state.tickets = payload;
	},
	setTicket: (state, payload) => {
		state.ticket = payload;
	},
};

export default {
	state,
	mutations,
	actions,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/tickets/store.js